var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepv2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0E0E21",
    fillRule: "nonzero",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 15.245l-1.24-.805a.25.25 0 01-.079-.337l4.784-8.111a.49.49 0 01.42-.242h1.129a.49.49 0 01.42.242l4.784 8.111a.25.25 0 01-.079.337l-1.24.805a.244.244 0 01-.341-.082l-4.003-6.786a.122.122 0 00-.21 0l-4.003 6.786a.243.243 0 01-.342.082zm11.477.995l1.904 3.228a.504.504 0 01-.155.674l-8.51 5.53a.484.484 0 01-.53 0l-8.51-5.53a.5.5 0 01-.156-.674l1.904-3.228a.243.243 0 01.342-.082l1.239.805a.25.25 0 01.079.337l-1.088 1.845a.127.127 0 00.04.168l6.348 4.125c.04.027.09.027.131 0l6.35-4.125a.125.125 0 00.04-.168L21.367 17.3a.25.25 0 01.079-.337l1.24-.805a.243.243 0 01.341.082z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepv2);
export default __webpack_public_path__ + "static/media/repv2.41091c07f7232004fe8b162e6609497e.svg";
export { ForwardRef as ReactComponent };